module.exports = __webpack_public_path__ + "static/media/3DPPA32.32d090dd.jpg";